import React, { useState } from 'react'

const Service = ({ name, videoUrl, description, thumbnail }) => {
  const [showPlayer, setShowPlayer] = useState(false);

  // Extract YouTube video ID from the URL
  const getYouTubeId = (url) => {
    const match = url.match(/(?:youtube\.com\/embed\/|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : null;
  };
  const videoId = getYouTubeId(videoUrl);

  return (
    <div className="service-card">
      <div className="service-video-wrapper">
        {!showPlayer ? (
          <div className="yt-thumbnail-wrapper" onClick={() => setShowPlayer(true)} style={{ position: 'relative', cursor: 'pointer' }}>
            <img src={thumbnail} alt={name} style={{ width: '100%', borderRadius: '0.8rem' }} />
            <span className="custom-play-btn" />
          </div>
        ) : (
          <iframe
            src={`https://www.youtube.com/embed/${videoId}?autoplay=1&controls=0&showinfo=0&rel=0&modestbranding=1`}
            title={name}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            style={{ width: '100%', height: '100%', borderRadius: '0.8rem' }}
          />
        )}
      </div>
      <div className="service-title-wrapper">
        <h3 className="service-title creative-title">{name}</h3>
        <span className="service-title-underline"></span>
        {description && <p className="service-desc">{description}</p>}
      </div>
    </div>
  )
}

export default Service